export class BreadcrumbModel {
  public url: string = '';
  public nameKey: string = '';

  constructor(nameKey: string, url: string) {
    this.nameKey = nameKey;
    this.url = url;
  }
};
